import React from "react";
import { Heart, Home, FileText } from "lucide-react";

const cards = [
  {
    icon: Heart,
    title: "Anerkannter Pflegegrad",
    description:
      "Pflegegrad 1 bis 5 – der gesetzliche Anspruch besteht für alle anerkannten Pflegegrade.",
  },
  {
    icon: Home,
    title: "Häusliche Pflege",
    description:
      "Die Pflege findet zu Hause statt – durch Angehörige, Bekannte oder Sie selbst.",
  },
  {
    icon: FileText,
    title: "Gesetzliche Pflegeversicherung",
    description:
      "Versicherte Person ist Mitglied einer gesetzlichen oder privaten Pflegekasse.",
  },
];

export const Voraussetzungen = () => {
  return (
    <section
      id="voraussetzungen"
      data-testid="voraussetzungen-section"
      className="relative py-24 sm:py-32 overflow-hidden bg-[#E8F5EC]"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(63,166,109,0.18),_transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-16">
          <div className="md:col-span-7">
            <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
              Voraussetzungen
            </div>
            <h2
              data-testid="voraussetzungen-headline"
              className="text-[3rem] sm:text-7xl lg:text-8xl font-medium leading-[0.95] tracking-tight text-gradient-dark"
            >
              Pflegegrad
              <br />
              <span className="text-gradient-green">1 – 5</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-base sm:text-lg text-[#5A5F66] leading-relaxed">
              Wenn ein Pflegegrad anerkannt ist und die Pflege zu Hause erfolgt,
              haben Sie laut §40 SGB XI Anspruch auf monatliche
              Pflegehilfsmittel – ohne Eigenanteil.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              data-testid={`voraussetzungen-card-${title}`}
              className="rounded-3xl bg-white/70 backdrop-blur border border-[#1A1A1F]/[0.06] p-8 hover:bg-white transition-colors shadow-[0_12px_30px_-20px_rgba(0,0,0,0.15)]"
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-2xl bg-[#3FA66D]/12 border border-[#3FA66D]/30 mb-6">
                <Icon size={20} className="text-[#3FA66D]" />
              </div>
              <h3 className="text-xl font-medium text-[#1A1A1F]">{title}</h3>
              <p className="mt-3 text-sm text-[#5A5F66] leading-relaxed">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Voraussetzungen;
